<div
  class="cd-backdrop"
  *ngIf="isVisible"
  (click)="cancel()"
  aria-modal="true"
  role="dialog"
>
  <div
    class="cd-panel"
    [class.cd-panel--blocked]="isBlocked"
    (click)="$event.stopPropagation()"
    role="alertdialog"
    [attr.aria-labelledby]="'cd-title'"
    [attr.aria-describedby]="'cd-message'"
  >

    <!-- ── Icône centrale ── -->
    <div class="cd-icon-wrap">
      <div class="cd-icon-ring cd-icon-ring--outer" [class.cd-icon-ring--warn]="isBlocked"></div>
      <div class="cd-icon-ring cd-icon-ring--inner" [class.cd-icon-ring--warn]="isBlocked"></div>
      <div class="cd-icon-circle" [class.cd-icon-circle--warn]="isBlocked">
        <mat-icon>{{ isBlocked ? 'block' : 'delete_forever' }}</mat-icon>
      </div>
    </div>

    <!-- ── Texte ── -->
    <div class="cd-text">

      <!-- Mode normal -->
      <ng-container *ngIf="!isBlocked">
        <h2 class="cd-title" id="cd-title">{{ title }}</h2>
        <p class="cd-message" id="cd-message">{{ message }}</p>
        <div *ngIf="itemLabel" class="cd-item-label">
          <mat-icon class="cd-item-label__icon">label</mat-icon>
          <span>{{ itemLabel }}</span>
        </div>
      </ng-container>

      <!-- Mode bloqué -->
      <ng-container *ngIf="isBlocked">
        <h2 class="cd-title" id="cd-title">Suppression impossible</h2>
        <p class="cd-message" id="cd-message">
          L'intervention <strong>« {{ itemLabel }} »</strong> contient
          <strong>{{ blockedChildCount }} sous-intervention(s)</strong>.
        </p>
        <div class="cd-blocked-hint">
          <mat-icon class="cd-blocked-hint__icon">info_outline</mat-icon>
          <span>Supprimez d'abord toutes les sous-interventions avant de pouvoir supprimer cet élément.</span>
        </div>
      </ng-container>

    </div>

    <!-- ── Actions ── -->
    <div class="cd-actions">

      <!-- Annuler / Fermer -->
      <button
        type="button"
        class="cd-btn cd-btn--cancel"
        [class.cd-btn--full]="isBlocked"
        (click)="cancel()"
        [disabled]="isLoading"
      >
        <mat-icon>close</mat-icon>
        {{ isBlocked ? 'Fermer' : cancelLabel }}
      </button>

      <!-- Confirmer — masqué si bloqué -->
      <button
        *ngIf="!isBlocked"
        type="button"
        class="cd-btn cd-btn--confirm"
        (click)="confirm()"
        [disabled]="isLoading || !confirmReady"
        [class.cd-btn--loading]="isLoading"
        [class.cd-btn--waiting]="!confirmReady && !isLoading"
      >
        <!-- Chargement API -->
        <ng-container *ngIf="isLoading">
          <span class="cd-spinner"></span>
          Suppression…
        </ng-container>

        <!-- Countdown actif -->
        <ng-container *ngIf="!isLoading && !confirmReady">
          <span class="cd-countdown">{{ countdown }}</span>
          {{ confirmLabel }}
        </ng-container>

        <!-- Prêt -->
        <ng-container *ngIf="!isLoading && confirmReady">
          <mat-icon>delete</mat-icon>
          {{ confirmLabel }}
        </ng-container>
      </button>

    </div>
  </div>
</div>